import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',

      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
      },
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '24px',
      width: 'fit-content',

      /*[theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: '24px',
        width: '100%',
      },*/
    },
    // Title styles are now imported from HeaderStyles for consistency
    logoBadge: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#F5F1EA',
      borderRadius: '8px',
      padding: '8px 16px',
      height: '40px',
      width: 'fit-content',
    },
    logoImage: {
      height: '24px',
      width: 'auto',
      objectFit: 'contain',
    },
    logoText: {
      fontSize: '16px',
      fontWeight: 500,
      color: '#313131',
    },
    rightSection: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#F5F1EA',
      borderRadius: '8px',
      height: '40px',
      overflow: 'hidden',
      width: 'fit-content',
    },
    lastUpdateContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px 16px',
    },
    lastUpdateText: {
      fontSize: '15px',
      fontWeight: 400,
      color: '#000000',
      margin: 0,
      whiteSpace: 'nowrap',
    },
    lastUpdateDate: {
      fontSize: '15px',
      fontWeight: 400,
      color: '#000000',
      marginLeft: '4px',
    },
    statusBadge: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      backgroundColor: '#193819',
      borderRadius: '8px',
      padding: '4px 16px',
      height: '100%',
      minWidth: '148px',
      boxShadow: '0px 4px 4px 0px rgba(232, 232, 232, 0.25)',
    },
    statusIcon: {
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    statusText: {
      fontSize: '12px',
      fontWeight: 400,
      color: '#8EC28D',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      margin: 0,
    },
  }),
  { name: 'PosIntegrationPageTitle' },
);

export default useStyles;
